import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "flex px-4 py-2 text-gray-700" }
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_AddButton, {
          onClick: _ctx.addItem,
          class: "mb-4"
        }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_Modal, {
        title: "Agregar consulta",
        visible: _ctx.showModalAdd,
        "onUpdate:visible": _cache[4] || (_cache[4] = (e) => _ctx.showModalAdd = e)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TextField, {
            label: "Pregunta",
            model: _ctx.questionField,
            "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.questionField) = $event)),
            type: "text",
            name: "name"
          }, null, 8, ["model"]),
          _createVNode(_component_TextField, {
            label: "Respuesta",
            model: _ctx.answerField,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.answerField) = $event)),
            type: "textarea",
            name: "name"
          }, null, 8, ["model"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "px-4 py-2 mr-2 bg-danger hover:bg-red-700 text-white focus:bg-red-700 rounded-md",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalAdd = false))
            }, "Cancelar"),
            _createElementVNode("button", {
              class: _normalizeClass(["px-4 py-2 bg-success text-white hover:bg-green-700 focus:bg-green-700 rounded-md", { 'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled }]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveAddItem && _ctx.saveAddItem(...args))),
              disabled: !_ctx.isFieldsFilled
            }, "Agregar", 10, _hoisted_3)
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    (_ctx.formattedQueries)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formattedQueries, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_Accordion, {
              items: [item],
              headerColor: 'bg-success'
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(item.content), 1)
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "flex px-4 py-2 mb-2 text-sm font-medium text-white bg-warning rounded-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-warning",
                    onClick: ($event: any) => (_ctx.editItem(index))
                  }, " Editar ", 8, _hoisted_6),
                  _createElementVNode("button", {
                    class: "flex px-4 py-2 ml-2 mr-2 mb-2 text-sm font-medium text-white bg-danger rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-danger",
                    onClick: ($event: any) => (_ctx.deleteItem(index))
                  }, " Eliminar ", 8, _hoisted_7)
                ]),
                _createVNode(_component_ModalAlert, {
                  title: 'Eliminar consulta',
                  message: '¿Esta seguro de eliminar esta consulta?',
                  visible: _ctx.showAlertModal,
                  onAccept: _ctx.handleAccept,
                  onCancelAlert: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAlertModal = false))
                }, null, 8, ["visible", "onAccept"])
              ]),
              _: 2
            }, 1032, ["items"])
          ]))
        }), 128))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      title: "Editar consulta",
      visible: _ctx.showModalEdit,
      "onUpdate:visible": _cache[10] || (_cache[10] = (e) => _ctx.showModalEdit = e)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Pregunta",
          model: _ctx.questionField,
          "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.questionField) = $event)),
          type: "text",
          name: "name"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Respuesta",
          model: _ctx.answerField,
          "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.answerField) = $event)),
          type: "textarea",
          name: "name"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 bg-gray-300 hover:bg-gray-400 text-white focus:bg-gray-400 rounded-md",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showModalEdit = false))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 bg-green-500 text-white hover:bg-green-700 focus:bg-green-700 rounded-md", { 'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled }]),
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveEditItem && _ctx.saveEditItem(...args))),
            disabled: !_ctx.isFieldsFilled
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Editar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
          ], 10, _hoisted_9)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.showAceptAlert)
      ? (_openBlock(), _createBlock(_component_ModalAlert, {
          key: 1,
          option: true
        }))
      : _createCommentVNode("", true)
  ]))
}